/***
 *
 *   BILLING NAV
 *   Billing sub nav
 *
 **********/

import { useTranslate } from '@tolgee/react'
import { AuthContext, SubNav } from 'components/lib'
import { useContext } from 'react'

export function BillingNav() {
  const { t } = useTranslate()
  const authContext = useContext(AuthContext)

  const isOwner = ['owner', 'master'].includes(authContext.user?.permission)
  if (!isOwner) return
  return (
    <SubNav
      items={[
        { link: '/account/plans', label: t('eleo-your-plan', 'Your plan') },
        { link: '/account/packs', label: t('eleo-packs', 'Additional tokens') },
        { link: '/account/invoices', label: t('eleo-invoices', 'Invoices') },
        { link: '/account/card', label: t('eleo-card', 'Card') },
        { link: '/account/redeem', label: t('eleo-redeem', 'Redeem gift') },
      ]}
    />
  )
}
